import React from "react";
import { STATUS_OPTIONS } from "../../hooks/useLeads";

const statusFor = (lead) =>
  STATUS_OPTIONS.find((o) => o.v === (lead.status || "new")) || STATUS_OPTIONS[0];

const LeadRow = ({ lead, active, onSelect }) => {
  const s = statusFor(lead);
  return (
    <li>
      <button
        onClick={() => onSelect(lead)}
        data-testid={`admin-lead-row-${lead.id}`}
        className={`w-full text-left px-5 py-4 border-b border-gray-100 hover:bg-[#F0F4F8] transition-colors ${
          active ? "bg-[#F0F4F8]" : ""
        }`}
      >
        <div className="flex items-center justify-between gap-3">
          <div className="font-semibold text-[#0A192F] truncate">{lead.name}</div>
          <span
            className={`text-[10px] font-display uppercase tracking-wider px-2 py-0.5 ${s.color}`}
          >
            {s.label}
          </span>
        </div>
        <div className="text-xs text-[#0A192F]/60 mt-1 truncate">{lead.email}</div>
        <div className="text-[11px] text-[#0A192F]/40 mt-1">
          {new Date(lead.created_at).toLocaleString()} · {lead.project_type || "-"}
        </div>
      </button>
    </li>
  );
};

export const LeadsList = ({ leads, totalCount, activeId, onSelect }) => (
  <div className="lg:col-span-2 bg-white border border-gray-200 overflow-hidden">
    {leads.length === 0 ? (
      <div className="p-10 text-center text-[#0A192F]/50 text-sm">
        {totalCount === 0 ? "No leads yet." : "No matches for your search."}
      </div>
    ) : (
      <ul className="max-h-[60vh] overflow-y-auto">
        {leads.map((l) => (
          <LeadRow
            key={l.id}
            lead={l}
            active={activeId === l.id}
            onSelect={onSelect}
          />
        ))}
      </ul>
    )}
  </div>
);

export default LeadsList;
